/**
 * Shared biomarker progress bar: clinical range, optional optimal range,
 * and vertical value marker. Uses the same logic as Labs tab (extended range,
 * getUserValuePosition, getClinicalRangePosition).
 */
import React from 'react';
import {
  getUserValuePosition,
  getClinicalRangePosition,
  getExtendedRange
} from '../utils/biomarkerUtils';
import './BiomarkerProgressBar.css';

export default function BiomarkerProgressBar({
  biomarker,
  result,
  userGender,
  optimalRange = null
}) {
  const hasResult = !!result;
  const userValue = result ? parseFloat(result.value) : null;
  const userValuePosition = getUserValuePosition(biomarker, result, userGender);
  const clinicalRange = getClinicalRangePosition(biomarker, userGender, userValue);

  return (
    <div className="biomarker-progress">
      <div className="biomarker-progress-bar">
        {/* Green segment from 0 to user value when low is null and user has value (Labs-style) */}
        {hasResult && biomarker.clinical_low === null && userValuePosition !== null && (
          <div
            className="biomarker-progress-optimal-range"
            style={{
              left: '0%',
              width: `${userValuePosition}%`
            }}
          />
        )}
        {/* Clinical range background */}
        {(biomarker.clinical_low !== null || biomarker.clinical_high !== null) && (
          <div
            className="biomarker-progress-clinical-range"
            style={{
              left: `${clinicalRange.start}%`,
              width: `${clinicalRange.end - clinicalRange.start}%`
            }}
          />
        )}
        {/* Optimal range (dark green) - when provided by parent, same axis as clinical */}
        {optimalRange && (
          <div
            className="biomarker-progress-optimal-range"
            style={{
              left: `${optimalRange.start}%`,
              width: `${optimalRange.end - optimalRange.start}%`
            }}
          />
        )}
        {/* User value vertical line */}
        {hasResult && userValuePosition !== null && (
          <div
            className="biomarker-progress-value-line"
            style={{
              left: `${userValuePosition}%`
            }}
          />
        )}
      </div>
    </div>
  );
}

export { getExtendedRange, getUserValuePosition, getClinicalRangePosition };
